module.exports = __webpack_public_path__ + "img/po1.b766879d.jpg";